/// <reference path="latestoppurtunity.js" />
import React, { useState, useEffect, useRef } from 'react';
import './Search.css';
import { Link } from 'react-router-dom';
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { useStore } from '../StoreContext';
import { IoMdClose } from "react-icons/io";
import Select from 'react-select';
import { FaSearchPlus, FaSearchMinus } from "react-icons/fa";
const Search = () => {
    const [ErrorMessage, setErrorMessage] = useState("");
    const [query, setQuery] = useState('');
    const [animate, setAnimate] = useState(false);
    const { listening, transcript, resetTranscript } = useSpeechRecognition();
    const { searchText, setSearchText, startSearch, setStartSearch, isClearOn, setIsClearOn, setIsAdvanced, IsAdvanced,
       
        JupDurselectedValue, setJupDurselectedValue, setJupSalselectedValue, JupSalselectedValue, setIndustryselectedValue,
        IndustryselectedValue, searchClientNameText, setClientNameText, searchOppLeaderText, setOppLeaderText,
        searchOppSpltLeaderText, setOppSplitLeaderText, topRowSelectedValue, settopRowSelectedValue } = useStore();
    const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [indudstries, setIndudstries] = useState([]);
 
    const oppstatus = [
        { value: 'Closed', label: 'Closed' },
        { value: 'Open', label: 'Open' }
    ]

    const topRows = [
        { value: '10', label: '10' },
        { value: '30', label: '30' },
        { value: '50', label: '50' }
    ]

    const advancedSearchRef = useRef(null);
   

    useEffect(() => {
       
       
        

       
        
    },);


    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (advancedSearchRef.current && !advancedSearchRef.current.contains(event.target)) {
    //             setIsAdvancedSearchOpen(false); 
    //         }
    //     };
    
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, []);
    const toggleAdvancedSearch = () => {
        setIsAdvancedSearchOpen((prevState) => !prevState); 
    }
      

    const goToOpportunityData = (e) => {
        e.preventDefault()
        if (searchText === "") {
            setErrorMessage("Please Enter AccoutName / Opportunity Leader / Opportunity Id to search");
        } else {
            if (searchText?.length < 3) {
                setErrorMessage("Please Enter 3 character atleast to search");
            } else {
                setStartSearch(!startSearch)
                setIsClearOn(true)
                setErrorMessage('')
                setIsAdvanced(false)
            }
        }
    }


    const goToAdvanceSearch = (e) => {
        e.preventDefault()
        if ((JupDurselectedValue === "" && JupDurselectedValue.length===0)&&  searchClientNameText === "" && (JupSalselectedValue === "" || JupSalselectedValue.length === 0 )&& (IndustryselectedValue === "" || IndustryselectedValue.length===0)  && searchOppLeaderText === "" && searchOppSpltLeaderText==="") {
            setErrorMessage("Please select any Value");
        } else {
           // if (searchText?.length < 3) {
             //   setErrorMessage("Please Enter 3 character atleast to search");
           // } else {
           //     setStartSearch(!startSearch)
           //     setIsClearOn(true)
           //     setErrorMessage('')
            //    setIsAdvanced(false)
            //  }
            setStartSearch(!startSearch)
            setIsClearOn(true)
            setErrorMessage('')
            setIsAdvancedSearchOpen((prevState) => !prevState);
            setIsAdvanced(true);
           
        }

       
    }



    function ClosePopup() {
        setErrorMessage("");
    }

    function ClearSearch() {
        if (searchText.length > 0) {
            setSearchText('');
        }
        if (transcript.length > 0) {
            resetTranscript();
        }

        setStartSearch(!startSearch)
        setIsClearOn(false)
        ClearAdvancedSearch();
        setErrorMessage('')
        
        //localStorage.removeItem("SearcOpp");
    }


    function ClearAdvancedSearch() {
        setIsAdvanced(false)
        setOppLeaderText('');
        setOppSplitLeaderText('');
        setJupDurselectedValue('');
        setJupSalselectedValue('');
        setIndustryselectedValue('');
        settopRowSelectedValue('');
        setClientNameText('');
    }
   

    useEffect(() => {
        fetch('jupiterdata/GetDropdownData/Stage')
            .then(res => res.json())
            .then(data => setCategories(data))
            .catch(err => console.error('Error fetching categories:', err));
       

        fetch('jupiterdata/GetDropdownData/Industry')
            .then(res => res.json())
            .then(data => setIndudstries(data))
            .catch(err => console.error('Error fetching categories:', err));


        if (transcript?.length > 0) {
            setSearchText(transcript);
        } else {
            if (searchText?.length > 0) {
                setSearchText(searchText)
            } else
                if(IsAdvanced === false)
            {
                setIsClearOn(false)
            }
        }
        

    }, [transcript]);
   
    useEffect(() => {
        if (transcript?.length > 0 && listening === false) {
            setStartSearch(!startSearch)
            setIsClearOn(true)
        }
    }, [listening])

    const voiceListner = (transcript) => {
        setAnimate(true);
        SpeechRecognition.startListening({ language: "en-IN" });
        setSearchText(transcript)
        setIsClearOn(false)
        setErrorMessage('');
    }

    const inputSearchHandler = (e) => {
        setSearchText(e.target.value);
    }

    const inputClientSearchHandler = (e) => {
        setClientNameText(e.target.value);
    }

    const inputOppLeaderHandler = (e) => {
        setOppLeaderText(e.target.value);
    }

    const inputOppSplitLeaderHandler = (e) => {
        setOppSplitLeaderText(e.target.value);
    }

    
    const SaleStageDropDown = categories.map(row => ({
        value: row.name,
        label: row.name
    }));

    const IndustryDropDown = indudstries.map(row => ({
        value: row.name,
        label: row.name
    }));

   
    const handleChangeJupDur = (selected) => {
        setJupDurselectedValue(selected);
    };

    const handleChangeSaleStage = (selectedOptions) => {
        setJupSalselectedValue(selectedOptions);
    };

    const handleChangeIndustry = (selectedOptions) => {
        setIndustryselectedValue(selectedOptions);
    };

    const handleTopRows = (selected) => {
        settopRowSelectedValue(selected);
    };

    const hideSearchPopup = (e) => {
        setIsAdvancedSearchOpen(false)
    }

    return (


        <>
            <section className="search-main">
                <div className="search-top">
                    <div role="region" aria-live="assertive" aria-atomic="true" tabIndex="0">
                        {ErrorMessage && <div className='error-section text-center error-msge'>
                            <div className="alert alert-danger">
                                <span><strong>Alert!</strong> {ErrorMessage}.</span>
                                <button type='button' aria-label='Close' className='alert-close' onClick={ClosePopup}><i className="demo-icon icon-cross_special">&#x50;</i></button>
                            </div>
                        </div>}
                    </div>
                    <div className="search-top-info">
                        <h1>Track O2E Journey {isAdvancedSearchOpen}</h1>
                        <form className="search-card">
                            {/* <div className="search-card-icon">
                            <img src="./image/icons/search-icon.svg" alt="Search" />
                        </div> */}
                            <div className="search-card-input">
                                <input
                                    className="form-control"
                                    placeholder="Search by Account Name / Opportunity Leader / Opportunity Id"
                                    aria-label="Search by Account Name / Opportunity Leader / Opportunity Id"
                                    value={searchText}
                                    onChange={(e) => inputSearchHandler(e)}
                                />
                                {/*<input aria-label="Search by Account Name / Opportunity Leader / Opportunity Id" className="form-control" id="textSearch" type="text" defaultValue={localStorage.getItem("SearcOpp")} placeholder="Search by Account Name / Opportunity Leader / Opportunity Id" /> */}
                            </div>
                            <div className="search-card-button">
                                <button className="btn btn-lg btn-success" style={{paddingRight: '0px'}} onClick={(e) => goToOpportunityData(e)}>
                                    <i className="demo-icon icon-search_special" style={{ fontSize: '3.5rem' }}>&#xe83b;</i>
                                </button>

                                {/* <button className="btn btn-lg btn-success" id="btnClick" onChange={(e) => goToOpportunityData(e)} onClick={(e) => goToOpportunityData(e)} type="submit">Search</button> */}
                                <img
                                    src="./image/voiceSearch.svg"
                                    style={{ width: '4rem', height: '4.4rem' }}
                                    className={`btn btn-success ${listening ? "voice-btn" : ""}`}
                                    onClick={() => voiceListner(transcript)}
                                    alt="mice"
                                />
                            </div>
                           <div className='filter-btns'>
                                <button 
                                    type="button" 
                                    className="btn advanced-btn" 
                                    onClick={toggleAdvancedSearch}  
                                >
                                    {isAdvancedSearchOpen ? <><FaSearchMinus /> <span className='hide-sd'>Close Advanced Search</span></> : <><FaSearchPlus /> <span className='hide-sd'>Advanced Search</span></>}
                                </button>
                                <div className='statistics-sticky-btn' onClick={hideSearchPopup} data-toggle="modal" data-target="#staticsModal">
                                    <img src='./image/statistics.svg' alt='' />
                                </div>
                           </div>
                            {isAdvancedSearchOpen && (
                                <div className="advanced-search-block" ref={advancedSearchRef}>
                                    <div className="arrow-top"></div>
                                    <div className='search-close' onClick={toggleAdvancedSearch}><IoMdClose /></div>
                                    <div className="select-list">
                                        <div className="select-item">
                                            <label>Status</label>
                                            <Select value={JupDurselectedValue} options={oppstatus} onChange={handleChangeJupDur} />
                                        </div>
                                       
                                        <div className="select-item">
                                            <label>Sales Stage</label>
                                            <Select value={JupSalselectedValue} options={SaleStageDropDown} isMulti onChange={handleChangeSaleStage} />
                                            {/*<label>Sales Stage</label>*/}
                                            {/*<Select options={categories.name} />*/}
                                           
                                           
                                        </div>
                                        <div className="select-item">
                                            <label>Industry</label>
                                            <Select value={IndustryselectedValue} options={IndustryDropDown} isMulti onChange={handleChangeIndustry} />
                                            {/*<label>Sales Stage</label>*/}
                                            {/*<Select options={categories.name} />*/}


                                        </div>
                                        <div className="select-item">
                                            <label>Client Name</label>
                                            <input type='text' className='form-control' placeholder='Enter Client Name'
                                                value={searchClientNameText}
                                                onChange={(e) => inputClientSearchHandler(e)}
                                            />
                                        </div>
                                        <div className="select-item">
                                            <label>Opportunity Leader</label>
                                            <input type='text' className='form-control' placeholder='Enter Opportunity Leader'
                                                value={searchOppLeaderText}
                                                onChange={(e) => inputOppLeaderHandler(e)}
                                            />
                                        </div>
                                        <div className="select-item">
                                            <label>Opportunity Split Leader</label>
                                            <input type='text' className='form-control' placeholder='Enter Opportunity Split Leader'
                                                value={searchOppSpltLeaderText}
                                                onChange={(e) => inputOppSplitLeaderHandler(e)}
                                            />
                                        </div>
                                        <div className="select-item">
                                            <label>List Recent Opportunities</label>
                                            <Select value={topRowSelectedValue} options={topRows} onChange={handleTopRows} />
                                        </div>
                                    </div>
                                    <div className="search-btns">
                                        {/*<button type="button" className="btn advanced-btn black-btn">Clear Filter</button>*/}
                                        <button type="button" className="btn advanced-btn" onClick={(e) => goToAdvanceSearch(e)}>Search Records</button>
                                    </div>
                                </div>
                            )}
                            
                        </form>
                        
                    </div>
                </div>
               
                {isClearOn &&
                    <div className='oppurtunity-table-header guilde-line app-pad'>
                        <form>

                            <button onClick={ClearSearch} className='clear-search' type="submit">
                                Clear Search <i aria-hidden="true" className="demo-icon icon-cross_special">&#x50;</i>
                            </button></form>
                    </div>
                }
                <div className="Error">
                </div>
            </section>
        </>
    )
}

export default Search;